<template>
    <div class="order-modal order-modal_mw380">  
        <div class="order-modal__head">
            <div class="order-modal__title mb10"> 
                <span>{{$t('orders.paymnetFailed')}}</span> 
            </div>
        </div>

        <div class="order-modal__body p30">   
            <div class="mb40 d-flex jcc">
                <img src="@/assets/images/payToMaster.png" alt="">
            </div> 
            
            <div class="order-modal__info mb30">
                <button class="btn d-flex jcc aic" @click="repeatPayment">
                    <img class="mr16" src="@/assets/images/retry.png" alt="">
                    <span>{{$t('orders.retry')}}</span>
                </button>
            </div>

            <div class="order-modal__info">
                <button class="btn" @click="changePaymentMethod">{{$t('orders.anotherMethod')}}</button>
            </div>

            <a 
                style="opacity:0;height:0" 
                ref="link" 
                :href="liqpayLink"
                target="_blank"
            >1</a>
        </div>
    </div>
</template> 

<script>
import {mapMutations, mapGetters} from 'vuex';

export default {
    data() {
        return {
            liqpayLink: 'https://google.com'
        }
    },
    computed: {
        ...mapGetters({
            order: 'orders/order'
        })
    },
    methods: {
        ...mapMutations({
            setState: 'main/setState',
            setIsComponent: 'orders/setIsComponent',
        }),
        close() {
            this.setState({
                key: 'mainModal',
                value: false
            }); 
        },
        changePaymentMethod() {
            this.setIsComponent('mainView');
        },
        repeatPayment() {
            this.liqpayLink = this.order.linkpay; 
            
            setTimeout(() => {
                this.$refs['link'].click();
            }, 100);
        }
    }
}
</script>

<style lang="scss" scoped>
.order-modal {
    &_mw380 {
        max-width: 380px;
        margin: 0 auto;
        position: relative;
    } 
}  
</style>